import { env } from '@/env';
import { ModuleBase } from "@/modules/base";
import { Component, Mixins, Vue } from 'vue-property-decorator';
import BaseLayer from "./BaseLayer.vue";
import DatasetMenu from "./DatasetMenu.vue";
import Menu from './Menu.vue';
import OverlayLayer from './OverlayLayer.vue';
import ParamsWindow from './ParamsWindow/index.vue';
import { range } from '@/utils/range';

@Component
export class SspDataModule extends Mixins(ModuleBase) {
  showParamsWindow = false

  frameStore() {
    @Component
    class FrameStore extends Vue {
      showSurface = true
      showFrame = true
      showFieldName = false

      params = defaultParams()
      activeReruns = env.releases.default.reruns

      get activeRerunsOrdered() {
        const reruns: string[] = []
        for (const r of env.releases) {
          reruns.push(...r.reruns)
        }
        return reruns.filter((r) => this.activeReruns.indexOf(r) >= 0)
      }
    }

    return new FrameStore()
  }

  get outlet() {
    return {
      baseLayer: BaseLayer,
      overlayLayer: OverlayLayer,
      window: ParamsWindow,
      analysisMenu: Menu,
      datasetMenu: DatasetMenu,
    }
  }
}

export function defaultParams() {
  return {
    type: MixerType.SDSS_TRUE_COLOR,
    filter: ['HSC-I', 'HSC-R', 'HSC-G'],
    simpleRgb: {
      beta: Math.exp(10),
      a: 1,
      bias: 0.05,
      b0: 0,
    },
    // sdssTrueColor: {
    //   beta: Math.exp(10),
    //   a: 1,
    //   bias: 0.05,
    //   b0: 0,
    // },
    sdssTrueColor: {
      beta: 57338.67405054002,
      a: 1.1040959890853042,
      bias: 0.05,
      b0: 0.00000722,
    },
    matrix: {
      beta: 57338.67405054002,
      a: 1.1040959890853042,
      bias: 0.05,
      b0: 0.00000722,
      matrix: range(9).map((i) => 1 / 3),
    },
  }
}

export enum MixerType {
  SIMPLE_RGB = 'SIMPLE_RGB',
  SDSS_TRUE_COLOR = 'SDSS_TRUE_COLOR',
  MATRIX = 'MATRIX',
}

export type Params = ReturnType<typeof defaultParams>
